// @ts-nocheck
/* eslint-disable lines-around-comment */
import React from 'react';
// @ts-expect-error
import UIEvents from '../../../../../service/UI/UIEvents';
import { createProfilePanelButtonEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
// @ts-ignore
import { AbstractDialogTab } from '../../../base/dialog';
import { translate } from '../../../base/i18n/functions';
import Button from '../../../base/ui/components/web/Button';
import Input from '../../../base/ui/components/web/Input';
import { openLogoutDialog } from '../../actions';
// CUSTOM
import { sendData } from '../../../webjam/websocket';
import { getBaseConfig, getStore } from '../../../customise/Utils';
import { SaveLog } from '../../../customise/Utils';
import { FEATURE_CUSTOM_REDUX } from '../../../customise/constant';
/**
 * React {@code Component} for modifying the local user's profile.
 *
 * @augments Component
 */
class ProfileTab extends AbstractDialogTab {
    /**
     * Initializes a new {@code ConnectedSettingsDialog} instance.
     *
     * @param {Props} props - The React {@code Component} props to initialize
     * the new {@code ConnectedSettingsDialog} instance with.
     */
    constructor(props) {
        super(props);
        // Bind event handlers so they are only bound once for every instance.
        this._onAuthToggle = this._onAuthToggle.bind(this);
        this._onDisplayNameChange = this._onDisplayNameChange.bind(this);
        this._onEmailChange = this._onEmailChange.bind(this);
    }
    /**
     * Changes display name of the user.
     *
     * @param {string} value - The key event to handle.
     *
     * @returns {void}
     */
    _onDisplayNameChange(value) {
        super._onChange({ displayName: value });
        // CUSTOM
        const { usersData } = getStore(FEATURE_CUSTOM_REDUX);
        localStorage.setItem('firstname', value);
        if (usersData && value) {
            var message = {
                action: {
                    firstname: value,
                    lastname: '',
                    uniqueID: usersData.uniqueId,
                },
                content: 'set-name',
                isBroadcast: true,
                sender: 'mobile',
            };
            //-------------Prepare logger data -------------
            var log_data = {
                functionName: '',
                triggeredBy: 'system',
                event: message.content,
                requestData: message,
                responseData: '',
                userId: '',
                boxId: message.action.uniqueID,
                message: 'Emit to server'
            };
            SaveLog(log_data);
            //-------------------------------------------
            sendData(message, '', 1);
        }
        // END
    }
    /**
     * Changes email of the user.
     *
     * @param {string} value - The key event to handle.
     *
     * @returns {void}
     */
    _onEmailChange(value) {
        super._onChange({ email: value });
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { authEnabled, displayName, email, hideEmailInSettings, readOnlyName, t // @ts-ignore
         } = this.props;
        // CUSTOM
        const profileNameEdit = getBaseConfig("profileNameEdit");
        // END
        return (React.createElement("div", null,
            React.createElement("div", { className: 'profile-edit' },
                React.createElement("div", { className: 'profile-edit-field' }, profileNameEdit == false ?
                    React.createElement(Input, { disabled: true, id: 'setDisplayName', label: t('profile.setDisplayNameLabel'), name: 'name', onChange: this._onDisplayNameChange, placeholder: t('settings.name'), type: 'text', value: displayName })
                    :
                        React.createElement(Input, { disabled: readOnlyName, id: 'setDisplayName', label: t('profile.setDisplayNameLabel'), name: 'name', onChange: this._onDisplayNameChange, placeholder: t('settings.name'), type: 'text', value: displayName }))),
            authEnabled && this._renderAuth()));
    }
    /**
     * Shows the dialog for logging in or out of a server and closes this
     * dialog.
     *
     * @private
     * @returns {void}
     */
    _onAuthToggle() {
        // @ts-ignore
        if (this.props.authLogin) {
            sendAnalytics(createProfilePanelButtonEvent('logout.button'));
            APP.store.dispatch(openLogoutDialog(() => APP.UI.emitEvent(UIEvents.LOGOUT)));
        }
        else {
            sendAnalytics(createProfilePanelButtonEvent('login.button'));
            APP.UI.emitEvent(UIEvents.AUTH_CLICKED);
        }
    }
    /**
     * Returns a React Element for interacting with server-side authentication.
     *
     * @private
     * @returns {ReactElement}
     */
    _renderAuth() {
        const { authLogin, t
        // @ts-ignore
         } = this.props;
        return (React.createElement("div", null,
            React.createElement("h2", { className: 'mock-atlaskit-label' }, t('toolbar.authenticate')),
            authLogin
                && React.createElement("div", { className: 'auth-name' }, t('settings.loggedIn', { name: authLogin })),
            React.createElement(Button, { accessibilityLabel: authLogin ? t('toolbar.logout') : t('toolbar.login'), id: 'login_button', label: authLogin ? t('toolbar.logout') : t('toolbar.login'), onClick: this._onAuthToggle })));
    }
}
ProfileTab.defaultProps = {
    displayName: '',
    email: ''
};
// @ts-ignore
export default translate(ProfileTab);
